<template>
    <div>
        <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide
                class="w-total"
                v-for="(item, index) in imgData"
                :key="`${index}_img`"
            >
                <div
                    class="slid-info p-r w-total flex a-i-c j-c-c"
                    :style="{ backgroundImage: `url(${item[langType]})` }"
                >
                    <ul class="p-a lh50 pl100 fw-s pc-hidden">
                        <li v-html="text" v-for="text in item.text" :class="{'text-center': index === 2}" :key="text"></li>
                    </ul>
                    <ul class="mobil">
                        <li v-html="text" v-for="text in item.text" :key="text"></li>
                    </ul>
                </div>
            </swiper-slide>
            <!-- 如果需要分页器 slot插槽 会自动往里面渲染分页器-->
            <div class="swiper-pagination" slot="pagination"></div>
            <!-- 如果需要导航按钮 -->
            <!-- <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
    name: "IristarCarousel",
    data() {
        return {
            swiperOptions: {
                // 自动高度
                // autoHeight: true,
                // 自动播放
                autoplay: true,
                // 环路播放
                loop: true,
                // 分页器
                pagination: {
                    type: "bullets",
                    el: ".swiper-pagination",
                    clickable: true,
                },
                // 前进后退按钮
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
        };
    },
    components: {
        Swiper,
        SwiperSlide,
    },
    computed: {
        langType() {
            return this.$store.state.language;
        },
    },
    props: {
        imgData: {
            type: Array,
            default: () => {
                return [
                    {
                        zh: "./static/img/_banner4.jpg",
                        en: "./static/img/_banner4en.jpg",
                        text: [
                            "超精准生物识别技术赋能的",
                            "&nbsp;&nbsp;&nbsp;多模态智慧服务提供商",
                        ],
                    },
                    {
                        zh: "./static/img/banner1.jpg",
                        en: "./static/img/banner1en.jpg",
                        text: [
                            "远距离虹膜人脸多模态超精准识别先行者",
                            "&nbsp;&nbsp;国家级虹膜识别标准的主导者和参与者",
                        ],
                    },
                    {
                        zh: "./static/img/banner2.jpg",
                        en: "./static/img/banner2en.jpg",
                        text: ["构建安全智慧场景&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;赋能企业转型升级"],
                        position: "center"
                    },
                ];
            },
        },
    },
};
</script>

<style lang="less" scoped>

</style>